import gql from "graphql-tag"

const getNewsletterRedirect = gql`
  query Get_Redirect {
    newsletterRedirect
  }
`

const dashboardRouteFieldsFragment = gql`
  fragment dashboardRouteFields on DashboardRoute {
    id
    path
    displayName
    chapters {
      id
      path
      displayName
    }
  }
`

const getResearchRoutes = gql`
  query tsisEtsDropdownQuery {
    viewer {
      id
    }
    tsisRoutes: dashboardRoutes(
      dataset: "TSIS"
      excludePaths: ["drill-downs"]
    ) {
      ...dashboardRouteFields
    }
    drilldownsRoutes: dashboardRoutes(
      dataset: "TSIS"
      favoriteType: "drilldown"
    ) {
      ...dashboardRouteFields
    }
    etsRoutes: dashboardRoutes(dataset: "ETS") {
      ...dashboardRouteFields
    }
    adminRoutes: dashboardRoutes(dataset: "ADMIN") {
      ...dashboardRouteFields
    }
  }
  ${dashboardRouteFieldsFragment}
`

export { getResearchRoutes, getNewsletterRedirect }
